import React from "react";

class Submenu extends React.Component {
    render() {
        const {
            sortByTitle,
            sortByDate,
            sortByPopularity,
            clearMovies,
            filterMovies,
            clearFilter,
        } = this.props;
        return (
            <div className="submenu-wrapper">
                <div className="submenu-container">
                    <div className="submenu">
                        <span style={{ padding: "6px 10px" }}>
                            <span className="icon-filter" />&nbsp;Filter(s):
                        </span>
                    </div>
                    <div className="submenu">
                        <div className="menu-section">
                            <select
                                name="favwatched"
                                defaultValue="favorites"
                                onChange={filterMovies}
                            >
                                <option value="favorites">
                                    View Favorites
                                </option>
                                <option value="watched">View Watched</option>
                            </select>
                        </div>
                    </div>
                    <div className="submenu">
                        <div className="menu-section">
                            <select
                                name="releasedate"
                                defaultValue="asc"
                                onChange={sortByPopularity}
                            >
                                <option value="asc">Popularity (↓↑)</option>
                                <option value="desc">Popularity (↑↓)</option>
                            </select>
                        </div>
                    </div>
                    <div className="submenu">
                        <div className="menu-section">
                            <select
                                name="releasedate"
                                defaultValue="asc"
                                onChange={sortByTitle}
                            >
                                <option value="asc">Title (↓↑)</option>
                                <option value="desc">Title (↑↓)</option>
                            </select>
                        </div>
                    </div>
                    <div className="submenu">
                        <div className="menu-section">
                            <select
                                name="releasedate"
                                defaultValue="asc"
                                onChange={sortByDate}
                            >
                                <option value="asc">Date (↓↑)</option>
                                <option value="desc">Date (↑↓)</option>
                            </select>
                        </div>
                    </div>
                    <div className="submenu">
                        <div className="menu-section">
                            <button onClick={clearFilter}>
                                <span className="icon-warning" /> Clear
                                Filter(s)
                            </button>
                        </div>
                    </div>
                </div>

                <div className="submenu-container">
                    <div className="submenu">
                        <div className="menu-section">
                            <button onClick={clearMovies}>
                                <span className="icon-warning" /> Clear
                                Everything
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Submenu;



// WEBPACK FOOTER //
// ./src/components/Submenu.js